import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, Observable, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AppNotifications } from "../shared/mail";
import { orderPost } from "../shared/interfaces/order";
import { User } from "../shared/user";

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  getDatos: any;
  // credenciales
  urlBase = environment.urlBase;
  apikey = environment.apikey;
  apikeyianos = environment.apiKeyianos;
  urlBaseianos = environment.apiBaseUrl;

  constructor(
    private http: HttpClient
  ) {
  }

  sendPUT_ProductStock(stockData: any, productId: string) {
    const headers = new HttpHeaders({
      'api-key': this.apikey,
      'Content-Type': 'application/json',
    });

    const body = {
      stock: stockData.products_stock,
      availability: stockData.product_availability,
      background: stockData.product_background_availability
    };

    return this.http.put<any>(
      `${this.urlBase}products/v1/info/stock/${productId}`,
      body,
      { headers }
    ).toPromise();
  }


  sendGET_SettingsApp() {
    const headers = new HttpHeaders();
    return this.getDatos = this.http.get<any>(this.urlBase + '/SettingsApp/RegisterScreen/' + this.apikey + '/1/1', { headers });
  }

  sendGET_Splashscreen() {
    const headers = new HttpHeaders();
    return this.getDatos = this.http.get<any>(this.urlBase + '/SettingsApp/SplashScreen/' + this.apikey + '/1/1', { headers });
  }

  sendGET_OneSettingsApp(id: string) {
    const headers = new HttpHeaders();
    return this.getDatos = this.http.get<any>(this.urlBase + '/SettingsApp/' + id + '/' + this.apikey + '/1/1', { headers });
  }

  sendGET_Menu() {
    const headers = new HttpHeaders();
    return this.getDatos = this.http.get<any>(this.urlBase + '/AdminMenu/q2d1GFsX93H1NMAT4MXo/' + this.apikey + '/1/1', { headers });
  }

  //bussines place
  sendGET_BusinessPlace() {
    const headers = new HttpHeaders();
    return this.getDatos = this.http.get<any>(this.urlBase + '/BusinessPlace/' + this.apikey + '/1/1', { headers });
  }

  sendGET_BusinessPlace1() {
    const headers = new HttpHeaders();

    return this.http.get<any>(
      this.urlBase + '/BusinessPlace/' + this.apikey + '/1/0',
      { headers }
    ).pipe(
      tap({
        next: response => console.log('BusinessPlace Response:', response),
        error: error => console.error('BusinessPlace Error:', error)
      })
    );
  }

  sendGET_BusinessPlace_One(id: string) {
    const headers = new HttpHeaders();
    return this.getDatos = this.http.get<any>(this.urlBase + '/BusinessPlace/' + id + '/' + this.apikey + '/1/1', { headers });
  }

  async sendPUT_Business(messages: any, id: string) {
    return new Promise((resolve, reject) => {
      let raw = JSON.stringify(messages);
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
      });

      this.getDatos = this.http.put<any>(this.urlBase + '/BusinessPlace/' + id + '/' + this.apikey + '/1/1', raw, { headers })
        .subscribe(data => {
          resolve(data);
        }, error => {
          reject(error);
        });
    })
  }

  sendPOST_Business(messages: any) {
    return new Promise((resolve, reject) => {
      let raw = JSON.stringify(messages);
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
      });

      return this.getDatos = this.http.post<any>(this.urlBase + '/BusinessPlace/' + this.apikey + '/1/1', raw, { headers })
        .subscribe(data => {
          resolve(data)
        }, error => {
        });
    })
  }

  // sendGET_Orders() {
  //   const headers = new HttpHeaders();
  //   return this.getDatos = this.http.get<any>(this.urlBase + '/Orders/' + this.apikey + '/1/1', { headers });
  // }

  // sendGET_OrdersOne(id: string) {
  //   const headers = new HttpHeaders();
  //   return this.getDatos = this.http.get<any>(this.urlBase + '/Orders/' + id + '/' + this.apikey + '/1/1', { headers });
  // }

  getOneOrders(id: string): Observable<any> {
    const headers = new HttpHeaders();
    return this.getDatos = this.http.get<any>(this.urlBase + '/Orders/' + id + '/' + this.apikey + '/1/1', { headers });
  }

  // getOrdersByStatus(status: string) {
  //   const headers = new HttpHeaders();
  //   return this.getDatos = this.http.get<any>(this.urlBase + '/Orders/' + this.apikey + '/' + status + '/1/1/1/1/1', { headers });
  // }

  sendGET_Home_List_Product() {
    const headers = new HttpHeaders();
    return this.getDatos = this.http.get<any>(this.urlBase + '/Products/' + this.apikey + '/0/1', { headers });
  }

  sendGET_Home_List_Product_All() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'qs-limit': "6000",
    });
    return this.getDatos = this.http.get<any>(this.urlBase + '/Products/' + this.apikey, { headers });
  }

  sendGET_Products_By_BusinessPlace(businessPlaceId: string, limit: number = 100) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    // URL: /Products/{apikey}/{uid_user}/{total_docs}/{num_page}/{limit}/{offset}/{business_place_uid}/{order_by}
    return this.http.get<any>(
      `${this.urlBase}/Products/${this.apikey}/0/6000/1/${limit}/0/${businessPlaceId}/product_name`,
      { headers }
    );
  }

  sendGET_Products_By_BusinessPlace_Category(businessPlaceId: string, categoryId: string) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    // URL: /Products/{apikey}/{business_place_uid}/{uid_category}/{total_docs}/{num_page}/{limit}/{offset}/{order_by}/{order}
    return this.http.get<any>(
      `${this.urlBase}/Products/${this.apikey}/${businessPlaceId}/${categoryId}/6000/1/2000/0/product_name/asc`,
      { headers }
    );
  }

  CountryList() {
  return new Promise((resolve, reject) => {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'api-key': this.apikey
    });

    this.getDatos = this.http.get<any>(
      this.urlBase + '/countrylist/v1/list',
      { headers }
    ).subscribe(data => {
      resolve(data);
    }, error => {
      reject(error);
    });

  });
}

  sendGET_Home_List_Product_By_Page(data: { total_docs_by_collection: number; num_page: number; limit: number; offset: number; order_by: string; order: string; }) {
    const headers = new HttpHeaders();
    return this.getDatos = this.http.get<any>(this.urlBase + '/Products/' + this.apikey + '/1/' + data.total_docs_by_collection + '/' + data.num_page + '/' + data.limit + '/' + data.offset + '/' + data.order_by + '/' + data.order, { headers });
  }

  sendPOST_Home_List_Product_By_Page_Alls(
    business_place_uid: string,
    data: {
      total_docs_by_collection: number;
      num_page: number;
      limit: number;
      offset: number;
      order_by: string;
      order: string;
    }
  ): Promise<any> {

    const post = {
      apikey: this.apikey,
      total_docs_by_collection: data.total_docs_by_collection,
      limit: data.limit,
      num_items_by_page: data.limit, // corregido
      offset: data.offset,
      name_order_by: data.order_by,
      order_by: data.order,
      num_page: data.num_page,
      business_place_uid
    };

    console.log('📤 POST /Products/v2/read/all REQUEST:', post);

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    return new Promise((resolve, reject) => {
      this.http.post<any>(
        this.urlBase + '/Products/v2/read/all',
        post,
        { headers }
      ).subscribe(
        (response) => {
          console.log('📥 RESPONSE SUCCESS:', response);
          resolve(response);
        },
        (error) => {
          console.error('❌ RESPONSE ERROR:', error);
          reject(error);
        }
      );
    });
  }

  sendPOST_Reinvoicing(docId: string) {
    const headers = new HttpHeaders({
      'Api-Key': this.apikey,
      'Content-Type': 'application/json'
    });

    const body = { docId: docId };

    return this.http.post<any>(
      this.urlBase + 'erp/v1/reinvoicing',
      body,
      { headers }
    );
  }

  sendGET_One_Product(id: string) {
    const headers = new HttpHeaders({
      'api-key': this.apikey
    });
    // return this.getDatos = this.http.get<any>(this.urlBase + '/Products/' + id + '/' + this.apikey + '/0/1', { headers }); // Para Otros
    // return this.getDatos = this.http.get<any>(this.urlBase + '/Products/' + id + '/' + this.apikey + '/1/1', { headers }); // Para New Rolling
  }

  sendGET_One_Productv2(id: string) {
    const headers = new HttpHeaders();
    return this.getDatos = this.http.get<any>(this.urlBase + '/Products/0/0/' + id + '/' + this.apikey + '/0/1', { headers }); // Para Otros
  }

  sendGET_Category() {
    const headers = new HttpHeaders();
    return this.getDatos = this.http.get<any>(this.urlBase + '/Categories' + '/' + this.apikey + '/0/1', { headers });
  }

  sendGET(url: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this.http.get(url, { headers });
  }

  sendGET_PowertranzTransaction(apiKey: string, transactionIdentifier: string): Observable<any> {
    const url = `${this.urlBase}/powertranz/v1/transactions/${apiKey}/${transactionIdentifier}`;

    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this.http.get(url, { headers });
  }


  sendGET_One_Category(id: string) {
    const headers = new HttpHeaders();
    return this.getDatos = this.http.get<any>(this.urlBase + '/CategoriesApp/' + id + '/1/0', { headers });
  }

  sendGET_Categories() {
  const headers = new HttpHeaders();
  return this.getDatos = this.http.get<any>(this.urlBase + '/CategoriesApp/1/0', { headers });
}

  sendGET_UserOne(uid: string) {
    const headers = new HttpHeaders();
    return this.getDatos = this.http.get<any>(this.urlBase + '/Users/' + uid + '/' + this.apikey + '/1/1', { headers });
  }

  getOneUser(uid: string): Observable<any> {
    const headers = new HttpHeaders();
    return this.getDatos = this.http.get<any>(this.urlBase + '/Users/' + uid + '/' + this.apikey + '/1/1', { headers });
  }

  getAllUser(): Observable<any> {
    const headers = new HttpHeaders();
    return this.getDatos = this.http.get<any>(this.urlBase + '/Users/' + this.apikey + '/0/1', { headers });
  }

  sendGET_ProductoTop(): Observable<any> {
    const headers = new HttpHeaders();
    return this.getDatos = this.http.get<any>(this.urlBase + '/ProductsTop/' + this.apikey + '/1/1', { headers });
  }

  sendGET_HelpHeads(): Observable<any> {
    const headers = new HttpHeaders();
    return this.getDatos = this.http.get<any>(this.urlBase + '/HelpContent/heads/' + this.apikey, { headers });
  }

  sendGET_HelpContents(id: string): Observable<any> {
    const headers = new HttpHeaders();
    return this.getDatos = this.http.get<any>(this.urlBase + '/HelpContent/' + id + '/heads/contents/' + this.apikey, { headers });
  }

  async sendPOST_Category(messages: any) {
    let raw = JSON.stringify(messages);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    // console.log("http: ", raw);
    return this.getDatos = this.http.post<any>(this.urlBase + '/Categories/' + this.apikey + '/0/1', raw, { headers }).subscribe(data => {
    }, error => {
    });
  }

  async sendPUT_Category(messages: any, id: string, type = false) {
    let endUrl = type ? '/666' : `${'/' + this.apikey}/0/1`;
    return new Promise((resolve, reject) => {
      let raw = JSON.stringify(messages);
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'api-key': this.apikey,
      });

      this.getDatos = this.http.put<any>(this.urlBase + '/Categories/' + id + endUrl, raw, { headers })
        .subscribe(data => {
          resolve(data);
        }, error => {
          reject(error);
        });
    })
  }

  sendPUT_Orders(messages: any, id: string, total_update: any) {
    var raw = JSON.stringify({
      items: messages,
      badgeColor: "warning",
      orders_status_uid: "Modified",
      total: Number(total_update)
    });
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    return this.getDatos = this.http.put<any>(this.urlBase + '/Orders/' + id + '/' + this.apikey + '/1/1', raw, { headers })
      .subscribe(data => {
      }, error => {
      });
  }

  sendPUT_Orders_Accept(messages: any, id: string) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    return this.http.put<any>(`${this.urlBase}/Orders/${id}/${this.apikey}/1/1`, messages, { headers }).toPromise();
  }

  sendPUT_Product(messages: any, id: string) {
    return new Promise((resolve, reject) => {
      var raw = JSON.stringify(messages);
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
      });
      console.log("http: ", raw);

      this.getDatos = this.http.put<any>(this.urlBase + '/Products/' + id + '/' + this.apikey + '/0/1', raw, { headers })
        .subscribe(data => {
          console.log(data);
          resolve(data);
        }, error => {
          reject(error);
        });
    })
  }

  async sendDELETE_Product(id: string) {
    var raw = JSON.stringify({ product_active: false });
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    // console.log("http: ", raw);

    return this.getDatos = this.http.put<any>(this.urlBase + '/Products/' + id + '/' + this.apikey + '/0/1', raw, { headers })
      .subscribe(data => {
      }, error => {
      });
  }

  sendPOST_Product(messages: any) {
    return new Promise((resolve, reject) => {

      let raw = JSON.stringify(messages);

      console.log('=== SEND POST PRODUCT ===');
      console.log('URL:', this.urlBase + '/Products/' + this.apikey + '/0/1');
      console.log('Payload:', raw);

      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
      });

      this.getDatos = this.http
        .post<any>(
          this.urlBase + '/Products/' + this.apikey + '/0/1',
          raw,
          { headers }
        )
        .subscribe(
          data => {
            console.log('=== RESPONSE SUCCESS ===');
            console.log(data);
            resolve(data);
          },
          error => {
            console.error('=== RESPONSE ERROR ===');
            console.error('Status:', error.status);
            console.error('Message:', error.message);
            console.error('Error Body:', error.error);

            reject(error);
          }
        );
    });
  }

  sendGET_Settings() {
    const headers = new HttpHeaders();
    return this.getDatos = this.http.get<any>(this.urlBase + '/SettingsApp/' + this.apikey + '/1/1', { headers });
  }

  getStatusOrders() {
    const headers = new HttpHeaders();
    return this.getDatos = this.http.get<any>(this.urlBase + '/OrderStatus/' + this.apikey + '/1/1', { headers });
  }

  async sendEmail(messages) {
    return new Promise((resolve, reject) => {
      let raw = JSON.stringify(messages);
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
      });
      this.http.post<AppNotifications>(this.urlBase + '/AppNotifications/' + this.apikey + '', raw, { headers }).subscribe(data => {
        resolve(data);
      }, error => {
        reject(error)
      });
    })
  }

  getProductsByCategory(id, total_docs, num_page, limit, num_docs_page) {
    let headers = new HttpHeaders();
    return this.getDatos = this.http.get<any>(this.urlBase + `/Products/${this.apikey}/1/${id}/${total_docs}/${num_page}/${limit}/${num_docs_page}/product_name/asc`, { headers });
  }


/**
 * Obtiene productos de una subcategoría usando el endpoint con ineed=2
 * @param urlFriendly - URL amigable de la subcategoría
 * @param limit - Número de registros por página
 * @param offset - Número de página (empieza en 1)
 * @returns Observable con los productos
 */
getProductsBySubcategory(
  urlFriendly: string,
  limit: number = 10,
  offset: number = 1
): Observable<any> {

  const headers = new HttpHeaders()
    .set('api-key', this.apikey)
    .set('Limit', limit.toString())
    .set('Offset', offset.toString());

  const url = `${this.urlBase}Products/2/${urlFriendly}`;

  console.log('=== getProductsBySubcategory ===');
  console.log('URL:', url);
  console.log('urlFriendly:', urlFriendly);
  console.log('Limit:', limit);
  console.log('Offset:', offset);
  console.log('Headers:', {
    'api-key': this.apikey,
    'Limit': limit,
    'Offset': offset
  });

  return this.http.get<any>(url, { headers }).pipe(
    tap({
      next: (response) => {
        console.log('✅ Respuesta API:', response);
      },
      error: (error) => {
        console.error('❌ Error API:', error);
      },
      complete: () => {
        console.log('✔️ Petición completada');
      }
    })
  );
}

  async updateProduct(message_post, id_product) {
    return new Promise((resolve, reject) => {
      let raw = JSON.stringify(message_post);
      // console.log('raw put update product: ', raw);

      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'api-key': this.apikey,
      });
      return this.getDatos = this.http.put<any>(this.urlBase + `/Products/` + id_product, raw, { headers }).subscribe(data => {
        // console.log(data['_body']);
        resolve(data['_body']);
      }, error => {
        reject(error);
        //console.log(error);
      });
    })
  }

  getSubcategories(orderField: string, orderBy: string) {
    const headers = new HttpHeaders({
      'api-key': this.apikey,
    });
    return this.getDatos = this.http.get<any>(this.urlBase + `/SubCategories/${orderField}/${orderBy}`, { headers });
  }

  updateSubcategory(message_post, id_subcategory: any, b = false) {
    let endUrl = b ? `/SubCategories/${id_subcategory}/666` : `/SubCategories/${id_subcategory}`;
    return new Promise((resolve, reject) => {
      let raw = JSON.stringify(message_post);
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'api-key': this.apikey,
      });
      return this.getDatos = this.http.put<any>(this.urlBase + endUrl, raw, { headers }).subscribe(data => {
        resolve(data['_body']);
      }, error => {
        reject(error);
      });
    })
  }

  getSubcategory(id) {
    let headers = new HttpHeaders({
      'api-key': this.apikey,
    });
    return this.getDatos = this.http.get<any>(this.urlBase + `/SubCategories/${id}`, { headers });
  }

  async saveSubcategory(message_post) {
    let raw = JSON.stringify(message_post);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'api-key': this.apikey,
    });
    return this.getDatos = this.http.post<any>(this.urlBase + '/SubCategories', raw, { headers }).subscribe(data => {
    }, error => {
    });
  }

  sendGET_brand(orderField, orderBy) {
    const headers = new HttpHeaders({
      'api-key': this.apikey,
    });
    return this.getDatos = this.http.get<any>(this.urlBase + `/Brands/${orderField}/${orderBy}`, { headers });
  }

  sendGET_supplier(orderField, orderBy) {
    const headers = new HttpHeaders({
      'api-key': this.apikey,
    });
    return this.getDatos = this.http.get<any>(this.urlBase + `/Suppliers/${orderField}/${orderBy}`, { headers });
  }

  async sendPUT_Settings(messages, id) {
    return new Promise((resolve, reject) => {
      let raw = JSON.stringify(messages);
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
      });

      this.getDatos = this.http.put<any>(this.urlBase + '/SettingsApp/' + id + '/' + this.apikey + '/0/1', raw, { headers })
        .subscribe(data => {
          resolve(data);
        }, error => {
          reject(error);
        });
    })
  }

  async saveOrder(data) {
    return new Promise((resolve, reject) => {
      let raw = JSON.stringify(data);
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
      });
      this.http.post<orderPost>(this.urlBase + '/Orders/' + this.apikey + '/1/0', raw, { headers })
        .subscribe(data => {
          resolve(data)
        }, error => {
          reject(error);
        });
    });
  }

  async updateBrand(message_post, id) {
    return new Promise((resolve, reject) => {
      let raw = JSON.stringify(message_post);
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'api-key': this.apikey,
      });
      return this.getDatos = this.http.put<any>(this.urlBase + `/Brands/${id}`, raw, { headers }).subscribe(data => {
        // console.log(data['_body']);
        resolve(data['_body']);
      }, error => {
        reject(error);
        // console.log(error);
      });
    })
  }

  getBrand(id) {
    let headers = new HttpHeaders({
      'api-key': this.apikey,
    });
    return this.getDatos = this.http.get<any>(this.urlBase + `/Brands/${id}`, { headers });
  }

  async saveBrand(messages) {
    let raw = JSON.stringify(messages);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'api-key': this.apikey,
    });
    return this.getDatos = this.http.post<any>(this.urlBase + '/Brands', raw, { headers }).subscribe(data => {
    }, error => {
    });
  }

  getProductsView(data) {
    let headers = new HttpHeaders({
      'api-key': this.apikey,
      'length': data.length,
      'whereone': data.whereone,
    });
    return this.getDatos = this.http.get<any>(this.urlBase + `/ProductsView`, { headers });
  }

  updateUser(messages, uid) {
    let raw = JSON.stringify(messages);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.put<User>(this.urlBase + '/Users/' + uid + '/' + this.apikey + '/1/1', raw, { headers });
  }

  // getDashboardStatistics() {
  //   let headers = new HttpHeaders({
  //     'api-key': this.apikey,
  //   });
  //   return this.getDatos = this.http.get<any>(this.urlBase + `/Dashboard/v1/statistics`, { headers });
  // }

  getOrdersStatistics() {
    let headers = new HttpHeaders({
      'api-key': this.apikey,
    });
    return this.getDatos = this.http.get<any>(this.urlBase + `/Dashboard/orders/statistics`, { headers });
  }

  getUsersStatistics() {
    let headers = new HttpHeaders({
      'api-key': this.apikey,
    });
    return this.getDatos = this.http.get<any>(this.urlBase + `/Dashboard/users/statistics`, { headers });
  }

  async saveUser(messages: any) {
    return new Promise((resolve, reject) => {
      let raw = JSON.stringify(messages);
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
      });
      this.http.post<any>(this.urlBase + '/Users/' + this.apikey + '/1/0', raw, { headers })
        .subscribe(data => {
          resolve(data)
        }, error => {
          reject(error);
        });
    });
  }

  getClassifications(orderField, orderBy) {
    const headers = new HttpHeaders({
      'api-key': this.apikey,
    });
    return this.getDatos = this.http.get<any>(this.urlBase + `/Classifications/${orderField}/${orderBy}`, { headers });
  }

  updateClassification(message_post, id) {
    return new Promise((resolve, reject) => {
      let raw = JSON.stringify(message_post);
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'api-key': this.apikey,
      });
      return this.getDatos = this.http.put<any>(this.urlBase + `/Classifications/${id}`, raw, { headers }).subscribe(data => {
        resolve(data['_body']);
      }, error => {
        reject(error);
      });
    })
  }

  getClassification(id) {
    let headers = new HttpHeaders({
      'api-key': this.apikey,
    });
    return this.getDatos = this.http.get<any>(this.urlBase + `/Classifications/${id}`, { headers });
  }

  async saveClassification(messages) {
    let raw = JSON.stringify(messages);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'api-key': this.apikey,
    });
    return this.getDatos = this.http.post<any>(this.urlBase + '/Classifications', raw, { headers }).subscribe(data => {
    }, error => {
    });
  }

  async sendPOST_AppNotifications(messages) {
    let raw = JSON.stringify(messages);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    // console.log('mail Cancel Order - Cash: ', JSON.stringify(raw));
    return this.http.post<AppNotifications>(this.urlBase + '/AppNotifications/' + this.apikey + '', raw, { headers })
      .subscribe(data => {
      }, error => {
      });
  }

  getOneSlider(uid) {
    let headers = new HttpHeaders({
      'api-key': this.apikey,
    });
    return this.getDatos = this.http.get<any>(this.urlBase + `/Sliders/${uid}`, { headers });
  }

  async updateSlider(message_post, id) {
    return new Promise((resolve, reject) => {
      let raw = JSON.stringify(message_post);
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'api-key': this.apikey,
      });
      return this.getDatos = this.http.put<any>(this.urlBase + `/Sliders/${id}`, raw, { headers }).subscribe(data => {
        resolve(data['_body']);
      }, error => {
        reject(error);
      });
    })
  }

  getContentsWeb() {
    let headers = new HttpHeaders({
      'api-key': this.apikey,
    });
    return this.getDatos = this.http.get<any>(this.urlBase + `/ContentsWeb`, { headers });
  }

  updateContentsWeb(message_post, id) {
    return new Promise((resolve, reject) => {
      let raw = JSON.stringify(message_post);
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'api-key': this.apikey,
      });
      return this.getDatos = this.http.put<any>(this.urlBase + `/ContentsWeb/${id}`, raw, { headers }).subscribe(data => {
        resolve(data['_body']);
      }, error => {
        reject(error);
      });
    })
  }

  // getOrderByUid(uid) {
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json',
  //     'api-key': this.apikey,
  //   });
  //   return this.http.get<any>(this.urlBase + '/Orders/' + uid, { headers });
  // }

  sendPUT_Orders2(messages, id) {
    return new Promise((resolve, reject) => {
      var raw = JSON.stringify(messages);
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
      });

      return this.getDatos = this.http.put<any>(this.urlBase + '/Orders/' + id + '/' + this.apikey + '/1/1', raw, { headers })
        .subscribe(data => {
          resolve(data);
        }, error => {
          reject(error);
        });
    });
  }

  sendPUT_StockProducts(messages) {
    return new Promise((resolve, reject) => {
      var raw = JSON.stringify({ items: messages });
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'api-key': this.apikey,
      });

      return this.getDatos = this.http.put<any>(this.urlBase + '/Stock/v1/proccess/order', raw, { headers })
        .subscribe(data => {
          resolve(data);
        }, error => {
          reject(error);
        });
    });
  }

  async sendPOST_TwilioVerification(data) {
    return new Promise((resolve, reject) => {
      var raw = JSON.stringify(data);
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Api-Key': this.apikey,
      });

      return this.http.post<any>(`${this.urlBase}/sms/twilio/v1/start/verification`, raw, { headers }).subscribe(data => {
        resolve(data);
      }, error => {
        reject(error);
      });
    });
  }

  async sendPOST_TwilioCheck(data) {
    return new Promise((resolve, reject) => {
      var raw = JSON.stringify(data);
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Api-Key': this.apikey,
      });

      return this.http.post<any>(`${this.urlBase}/sms/twilio/v1/check/verification`, raw, { headers }).subscribe(data => {
        resolve(data);
      }, error => {
        reject(error);
      });
    });
  }

  async sendPOST_PushNotifications(data) {
    return new Promise((resolve, reject) => {
      var raw = JSON.stringify(data);
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Api-Key': this.apikey,
      });

      return this.http.post<any>(`${this.urlBase}/PushNotifications/sendNotification`, raw, { headers }).subscribe({
        next: (data) => {
          resolve(data);
        },
        error: (error) => {
          reject(error);
        }
      });
    });
  }


  async sendSingleMessage(data) {
    return new Promise((resolve, reject) => {
      const raw = JSON.stringify(data);
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Api-Key': this.apikey,
      });

      return this.http.post<any>(`${this.urlBase}/sms/twilio/v1/send/message`, raw, { headers })
        .subscribe(data => {
          resolve(data);
        }, error => {
          reject(error);
        });
    });
  }

  /**
   * Send SMS to Multiple Users (Bulk)
   */
  async sendBulkMessage(data) {
    return new Promise((resolve, reject) => {
      const raw = JSON.stringify(data);
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Api-Key': this.apikey,
      });

      return this.http.post<any>(`${this.urlBase}/sms/twilio/v1/send/bulk-message`, raw, { headers })
        .subscribe(data => {
          resolve(data);
        }, error => {
          reject(error);
        });
    });
  }

  sendGET_One_Productv3(id: string) {
    const headers = new HttpHeaders({
      'Api-Key': this.apikey
    });
    return this.http.get<any>(
      `${this.urlBase}products/v1/info/stock/${id}`,
      { headers }
    );
  }
sendGET_ListadoProductos() {
  const headers = new HttpHeaders({});

  const url = `${this.urlBaseianos}listado/${this.apikeyianos}/12`;

  return this.http.get<any>(url, { headers }).pipe(
    tap((response) => console.log('Respuesta:', response))
  );
}

  getDailySummary(body: { dateSummary: string }) {
    const headers = new HttpHeaders({
      'Api-Key': this.apikey,
      'Content-Type': 'application/json'
    });

    return this.http.post<any>(
      `${this.urlBase}orders/v1/daily/summary`,
      body,
      { headers }
    );
  }


  async sendPOST_Quotacion(messages: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const raw = JSON.stringify(messages);

      const headers = new HttpHeaders({
        //'Content-Type': 'application/json',
        //'Api-Key': this.apikeyianos // usa tu API key desde environment
      });

      this.http.post<any>(
        `${this.urlBaseianos}/cotizacionrapida/${this.apikeyianos}`,
        raw,
        { headers }
      ).subscribe({
        next: data => {
          resolve(data);
        },
        error: err => {
          reject(err);
        }
      });
    });
  }

  getOrdersByFilter(body: any) {
    const headers = new HttpHeaders({
      'Api-Key': this.apikey,
      'Content-Type': 'application/json'
    });

    console.log(' getOrdersByFilter payload:', body);

    return this.http.post<any>(
      `${this.urlBase}orders/v1/filters`,
      body,
      { headers }
    ).pipe(
      tap(response => console.log(' getOrdersByFilter response:', response)),
      catchError(error => {
        console.error(' getOrdersByFilter error:', error);
        throw error;
      })
    );
  }



  ////


  // Agregar al final de HttpService, antes de la última llave

/**
 * Busca productos para asignar a una subcategoría
 * @param searchTerm - Término de búsqueda (opcional)
 * @param limit - Número de registros por página
 * @param offset - Número de página
 */
getProductsForAssignment(searchTerm: string = '', limit: number = 20, offset: number = 1): Observable<any> {
    const headers = new HttpHeaders()
        .set('api-key', this.apikey)
        .set('Limit', limit.toString())
        .set('Offset', offset.toString());
    
    // Usar el endpoint existente para obtener productos
    let url = `${this.urlBase}/Products/${this.apikey}`;
    if (searchTerm && searchTerm.trim() !== '') {
        // Si el backend soporta búsqueda por query parameter
        url += `?search=${encodeURIComponent(searchTerm)}`;
    }
    
    console.log('🔍 Buscando productos para asignar:', { url, limit, offset, searchTerm });
    
    return this.http.get<any>(url, { headers });
}

/**
 * Asigna productos a una subcategoría
 * @param subcategoryUid - UID de la subcategoría
 * @param productUids - Array de UIDs de productos a asignar
 */
assignProductsToSubcategory(subcategoryUid: string, productUids: string[]): Promise<any> {
    return new Promise((resolve, reject) => {
        const raw = JSON.stringify({ 
            subcategory_uid: subcategoryUid,
            product_uids: productUids
        });
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'api-key': this.apikey,
        });
        
        console.log('📤 Asignando productos a subcategoría:', { subcategoryUid, productUids });
        
        this.http.post<any>(`${this.urlBase}/SubCategories/${subcategoryUid}/assign-products`, raw, { headers })
            .subscribe({
                next: (data) => {
                    console.log('✅ Productos asignados correctamente:', data);
                    resolve(data);
                },
                error: (error) => {
                    console.error('❌ Error al asignar productos:', error);
                    reject(error);
                }
            });
    });
}

/**
 * Elimina un producto de una subcategoría
 * @param subcategoryUid - UID de la subcategoría
 * @param productUid - UID del producto a remover
 */
removeProductFromSubcategory(subcategoryUid: string, productUid: string): Promise<any> {
    return new Promise((resolve, reject) => {
        const headers = new HttpHeaders({
            'api-key': this.apikey,
        });
        
        console.log('🗑️ Eliminando producto de subcategoría:', { subcategoryUid, productUid });
        
        this.http.delete<any>(`${this.urlBase}/SubCategories/${subcategoryUid}/products/${productUid}`, { headers })
            .subscribe({
                next: (data) => {
                    console.log('✅ Producto eliminado correctamente:', data);
                    resolve(data);
                },
                error: (error) => {
                    console.error('❌ Error al eliminar producto:', error);
                    reject(error);
                }
            });
    });
}


/**
 * Procesa los puntos de una orden completada.
 *
 * Endpoint:
 * POST /v1/award/:apikey/:user_uid/:order_uid
 *
 * @param userUid UID del usuario
 * @param orderUid UID de la orden
 */
sendPOST_AwardOrderPoints(
  userUid: string,
  orderUid: string
): Observable<any> {

  const headers = new HttpHeaders({
    'Content-Type': 'application/json'
  });

  //http://127.0.0.1:5001/ianos-app-sv-pollo-real-uat/us-central1/orders/
  const url =
    `${this.urlBase}/orders/v1/award/${this.apikey}/${userUid}/${orderUid}`;

  console.log('🎯 Procesando puntos de orden:', {
    url,
    userUid,
    orderUid
  });

  return this.http.post<any>(
    url,
    {},
    { headers }
  ).pipe(
    tap({
      next: response => {
        console.log('✅ Puntos procesados:', response);
      },
      error: error => {
        console.error('❌ Error procesando puntos:', error);
      }
    }),
    catchError(error => {
      console.error('❌ Error award points:', error);
      throw error;
    })
  );
}


/**
 * Buscar productos similares (antes de guardar).
 *
 * Endpoint:
 * POST /v1/products/similar/find/:apikey
 *
 * Emulador:
 * http://127.0.0.1:5001/ianos-app-sv-pollo-real-uat/us-central1/products/v1/products/similar/find/:apikey
 *
 * Producción:
 * https://us-central1-ianos-app-sv-pollo-real-uat.cloudfunctions.net/products/v1/products/similar/find/:apikey
 *
 * @param payload Datos para la búsqueda
 *   {
 *     product_name: string,
 *     category_uid?: string,
 *     url_product?: string,
 *     business_place_uid?: string,
 *     exclude_product_uid?: string,
 *     threshold?: number,
 *     limit?: number
 *   }
 */
sendPOST_SimilarProductsFind(
  payload: {
    product_name: string;
    category_uid?: string;
    url_product?: string;
    business_place_uid?: string;
    exclude_product_uid?: string;
    threshold?: number;
    limit?: number;
  }
): Observable<any> {

  const headers = new HttpHeaders({
    'Content-Type': 'application/json'
  });

  //http://127.0.0.1:5001/ianos-app-sv-pollo-real-uat/us-central1/products/
  const url =
    `${'http://127.0.0.1:5001/ianos-app-sv-pollo-real-uat/us-central1'}/products/v1/products/similar/find/${this.apikey}`;

  console.log('🔍 Buscando productos similares:', {
    url,
    payload
  });

  return this.http.post<any>(
    url,
    payload,
    { headers }
  ).pipe(
    tap({
      next: response => {
        console.log('✅ Productos similares encontrados:', response);
      },
      error: error => {
        console.error('❌ Error buscando similares:', error);
      }
    }),
    catchError(error => {
      console.error('❌ Error find similar:', error);
      throw error;
    })
  );
}

/**
 * Guardar producto principal + actualizar similares por UIDs.
 *
 * Endpoint:
 * PUT /v1/products/similar/save/:apikey/:product_uid
 *
 * Emulador:
 * http://127.0.0.1:5001/ianos-app-sv-pollo-real-uat/us-central1/products/v1/products/similar/save/:apikey/:product_uid
 *
 * Producción:
 * https://us-central1-ianos-app-sv-pollo-real-uat.cloudfunctions.net/products/v1/products/similar/save/:apikey/:product_uid
 *
 * @param productUid UID del producto principal
 * @param payload    Datos para guardar
 *   {
 *     product: { ...datos completos del producto... },
 *     sibling_uids: string[]
 *   }
 */
sendPUT_SimilarProductsSave(
  productUid: string,
  payload: {
    product: any;
    sibling_uids: string[];
  }
): Observable<any> {

  const headers = new HttpHeaders({
    'Content-Type': 'application/json'
  });

  //http://127.0.0.1:5001/ianos-app-sv-pollo-real-uat/us-central1/products/
  const url =
    `${'http://127.0.0.1:5001/ianos-app-sv-pollo-real-uat/us-central1'}/products/v1/products/similar/save/${this.apikey}/${productUid}`;

  console.log('💾 Guardando producto y similares:', {
    url,
    productUid,
    siblingsCount: payload.sibling_uids?.length || 0
  });

  return this.http.put<any>(
    url,
    payload,
    { headers }
  ).pipe(
    tap({
      next: response => {
        console.log('✅ Producto y similares guardados:', response);
      },
      error: error => {
        console.error('❌ Error guardando similares:', error);
      }
    }),
    catchError(error => {
      console.error('❌ Error save similar:', error);
      throw error;
    })
  );
}

}
